import { TBTabName } from "./enums";

export interface IndicatorDef {
  key: string;
  label: string;
  icon: string;
}

export interface TaskBankFilterOption {
  name: string;
  key: string;
  visibleOnTabs?: string[];
  hiddenOnTabs?: string[];
}

export const INDICATOR_DEFS: IndicatorDef[] = [
  {
    key: "is_same_day_shipment",
    label: "Same-Day Delivery",
    icon: "assets/image/same_day_icon.svg",
  },
  {
    key: "print_shipment",
    label: "Print Shipment",
    icon: "assets/image/print_shipment.png",
  }
];

const DEFAULT_SERVICE_CODE_FILTER: TaskBankFilterOption[] = [
  {
    name: "Same Day Delivery",
    key: "is_same_day_shipment",
    visibleOnTabs: [TBTabName.Planned, TBTabName.PushToCloud, TBTabName.Unloaded],
    hiddenOnTabs: [TBTabName.Unplannedpickup, TBTabName.PlannedPBM],
  },
  {
    name: "Print Shipment",
    key: "print_shipment",
    visibleOnTabs: [TBTabName.Planned, TBTabName.PlannedPBM, TBTabName.Unplannedpickup],
    hiddenOnTabs: [TBTabName.Unloaded, TBTabName.PushToCloud],
  },
];

const DEFAULT_EVENTS_FILTER: TaskBankFilterOption[] = [
  {
    name: "Regret Load",
    key: "is_regret_load",
    visibleOnTabs: [TBTabName.Unloaded],
    hiddenOnTabs: [TBTabName.Planned, TBTabName.PushToCloud, TBTabName.PlannedPBM, TBTabName.Unplannedpickup],
  },
];


const filterByTabVisibility = (
  options: TaskBankFilterOption[],
  tabName?: string
): TaskBankFilterOption[] => {
  if (!tabName?.toLowerCase()) {
    return options;
  }

  return options.filter((option) => {
    const hasVisibleTabs = !!option.visibleOnTabs?.length;
    const isVisibleTab = hasVisibleTabs
      ? option.visibleOnTabs?.includes(tabName?.toLowerCase())
      : true;
    const isHiddenTab = option.hiddenOnTabs?.includes(tabName?.toLowerCase()) ?? false;

    return isVisibleTab && !isHiddenTab;
  });
};

export const getServiceCodesByTab = (tabLabel?: string): TaskBankFilterOption[] => {
  return filterByTabVisibility(DEFAULT_SERVICE_CODE_FILTER, tabLabel?.toLowerCase());
};

export const getEventsByTab = (tabLabel?: string): TaskBankFilterOption[] => {
  return filterByTabVisibility(DEFAULT_EVENTS_FILTER, tabLabel?.toLowerCase());
};
